export function getStatusStyle(status: string) {
  switch (status) {
    case "pendente":
    case "PENDING":
    case "AWAITING_PAYMENT":
      return {
        label: status === "AWAITING_PAYMENT"
          ? "Pagamento iniciado"
          : "Pendente",
        className: "pendente",
      };

    case "pago":
    case "PAID":
      return {
        label: "Pago",
        className: "pago",
      };

    case "PREPARING":
      return {
        label: "Preparando pedido",
        className: "preparando",
      };

    case "enviado":
    case "SHIPPED":
      return {
        label: "Em trânsito",
        className: "transito",
      };

    case "entregue":
    case "DELIVERED":
      return {
        label: "Entregue",
        className: "entregue",
      };

    case "cancelado":
    case "CANCELED":
      return {
        label: "Devolvido",
        className: "devolvido",
      };

    default:
      return {
        label: status,
        className: "",
      };
  }
}

export const formatarNumeroPedido = (id: string) => {
  if (!id) return "";

  return id.split("-")[0].toUpperCase();
};
